import Konva from 'konva/konva'
import VariableBase, { separator } from './variable-base'
// import moment from 'moment'

const categoryHeight = 25 // height of 1 category value (step)
const verticalLine = { color: 'LightGray', width: 1 }
const categoryLine = { defaultColor: 'Gray', width: 4 }

export default class CategoryVariable extends VariableBase {
  constructor ({ width, yOffset, timeFrom, timeTo, now, nowX, name, config, values, yScaleData }) {
    super()
    Object.assign(this, { width, yOffset, timeFrom, timeTo, now, nowX, name, config, values, yScaleData })

    this.maxTime = Math.min(now, timeTo)
  }

  _getValuesHeight () {
    return categoryHeight * (this.config.length - 1)
  }

  _valueToY (value) {
    // convert value (Y axis) to canvas Y coordinate
    return separator.margin + this.yOffset + (this.config.length - 1 - value) * categoryHeight
  }

  _calculateVerticalLines () {
    return this.values
      .reduce((acc, [time, value], index, array) => {
        if (index > 0) {
          const prevValue = array[index - 1][1]
          const line = []
          this._addPoint(line, { time, value: prevValue })
          this._addPoint(line, { time, value })
          acc.push(line)
        }
        return acc
      }, [])
  }

  _calculateCategoryLines (category) {
    return this.values
      .reduce((acc, [time, value], index, array) => {
        if (value === category) {
          const nextTuple = array[index + 1]
          const timeTo = nextTuple ? nextTuple[0] : this.maxTime
          const line = []
          this._addPoint(line, { time, value: category })
          this._addPoint(line, { time: timeTo, value: category })
          acc.push(line)
        }
        return acc
      }, [])
  }

  _addScale () {
    const { config } = this
    const values = config.map(({ code }) => code)
    this.yScaleData.push({
      type: 'category',
      yFrom: this._valueToY(this.config.length - 1),
      yTo: this._valueToY(0),
      values
    })
  }

  render () {
    this.destroyChildren()

    // console.log(
    //   this.timeFrom + ' - ' + this.timeTo,
    //   moment(this.timeFrom).utc().format() + ' - ' + moment(this.timeTo).utc().format())
    // console.log(this.values)
    // this.values.forEach(([time, value]) => {
    //   console.log(time, value, moment(time).utc().format(),
    //     (time >= this.timeFrom && time <= this.timeTo) ? 'ok' : 'nok',
    //     (time < this.timeFrom) ? 'before' : '',
    //     (time > this.timeTo) ? 'after' : '')
    // })

    this._renderBackground()
    this._renderNoData()
    this._renderSeparators()

    this._calculateVerticalLines()
      .map(points => new Konva.Line({ points, stroke: verticalLine.color, strokeWidth: verticalLine.width }))
      .forEach(line => this.add(line))

    this.config
      .forEach((category, index) => {
        this._calculateCategoryLines(index)
          .map(points => new Konva.Line({
            points, stroke: category.color || categoryLine.defaultColor, strokeWidth: categoryLine.width
          }))
          .forEach(line => this.add(line))
      })

    this._renderFutureRect()
    this._addScale()
  }

  getLabelAtTime (time) {
    const value = this._getValueAtTime(time)
    if (value !== undefined) {
      return this.config[value].code
    }
  }
}
